import { reminderBaseModel } from './crud';

export * from './types';

export const useRemindersById = reminderBaseModel.fetchById();
export const useRemindersByIds = reminderBaseModel.fetchByIds();
export const useRemindersMany = reminderBaseModel.fetchMany();
export const useRemindersCount = reminderBaseModel.count();
export const useRemindersManyInfiniteQuery = reminderBaseModel.fetchPaginated();
export const useRemindersUpdateOne = reminderBaseModel.edit();
export const useRemindersCreateOne = reminderBaseModel.create();
export const useRemindersRemoveOne = reminderBaseModel.delete();
export const useRemindersRemoveByIds = reminderBaseModel.deleteByIds();

export const useRemindersByIdV2 = reminderBaseModel.fetchByIdV2();
export const useRemindersByIdsV2 = reminderBaseModel.fetchByIdsV2();
export const useRemindersManyV2 = reminderBaseModel.fetchManyV2();
export const useRemindersCountV2 = reminderBaseModel.countV2();
export const useRemindersManyInfiniteQueryV2 =
  reminderBaseModel.fetchPaginatedV2();
export const useRemindersUpdateOneV2 = reminderBaseModel.editV2();
export const useRemindersCreateOneV2 = reminderBaseModel.createV2();
export const useRemindersRemoveOneV2 = reminderBaseModel.deleteV2();
export const useRemindersRemoveByIdsV2 = reminderBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useReminderById = reminderBaseModel.fetchById();
export const useReminderByIds = reminderBaseModel.fetchByIds();
export const useReminderMany = reminderBaseModel.fetchMany();
export const useReminderCount = reminderBaseModel.count();
export const useReminderPagination = reminderBaseModel.fetchPaginated();
export const useReminderUpdateOne = reminderBaseModel.edit();
export const useReminderCreateOne = reminderBaseModel.create();
export const useReminderRemoveOne = reminderBaseModel.delete();
export const useReminderRemoveByIds = reminderBaseModel.deleteByIds();

export const useReminderByIdV2 = reminderBaseModel.fetchByIdV2();
export const useReminderByIdsV2 = reminderBaseModel.fetchByIdsV2();
export const useReminderManyV2 = reminderBaseModel.fetchManyV2();
export const useReminderCountV2 = reminderBaseModel.countV2();
export const useReminderPaginationV2 = reminderBaseModel.fetchPaginatedV2();
export const useReminderUpdateOneV2 = reminderBaseModel.editV2();
export const useReminderCreateOneV2 = reminderBaseModel.createV2();
export const useReminderRemoveOneV2 = reminderBaseModel.deleteV2();
export const useReminderRemoveByIdsV2 = reminderBaseModel.deleteByIdsV2();
